var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconLogin(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.81 1C6.18212 1 0.809998 6.37212 0.809998 13C0.809998 19.6279 6.18212 25 12.81 25C19.4379 25 24.81 19.6279 24.81 13C24.81 6.37212 19.4405 1 12.81 1Z",
    stroke: "#C1A1A7",
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7292 12.2783C14.7623 12.2783 16.4105 10.6302 16.4105 8.59706C16.4105 6.56394 14.7623 4.91577 12.7292 4.91577C10.6961 4.91577 9.04794 6.56394 9.04794 8.59706C9.04794 10.6302 10.6961 12.2783 12.7292 12.2783Z",
    stroke: "#C1A1A7",
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.81 12.2888C9.69405 12.2888 6.9168 13.977 5.11394 16.6083C6.86991 19.3283 9.66279 21.0868 12.81 21.0868C15.9572 21.0868 18.7527 19.3283 20.506 16.6083C18.7032 13.977 15.9259 12.2888 12.81 12.2888Z",
    stroke: "#C1A1A7",
    strokeMiterlimit: 10
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLogin);
export default __webpack_public_path__ + "static/media/iconLogin.daf33c971836a0b161a86a277b2c15fe.svg";
export { ForwardRef as ReactComponent };